import { render, staticRenderFns } from "./ClientGuardian.vue?vue&type=template&id=3a438f63&"
import script from "./ClientGuardian.vue?vue&type=script&lang=js&"
export * from "./ClientGuardian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports